import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Impersonate from 'modules/impersonate';
import * as OAuth from 'modules/oauth';
import AppChannel from 'modules/channels/App';
import { getActiveLanguage } from 'models/locales.js';

const BaseApplication = Marionette.Application.extend({
    initialize() {
        AppChannel.reqres.setHandler('special:headers', this.getSpecialHeaders);
        AppChannel.reqres.setHandler('special:parameters', this.getSpecialParameters);
        AppChannel.reqres.setHandler('special:query:parameters', this.getAccessQueryParameters);
    },

    register(instance, id) {
        this._registry = this._registry || {};
        this._registry[id] = instance;
    },

    unregister(instance, id) {
        delete this._registry[id];
    },

    resetRegistry() {
        const oldCount = this.getRegistrySize();
        _.each(this._registry, function(controller, key) {
            if (controller) {
                controller.region.empty();
            }
        });
        const msg = `There were ${oldCount} controllers in the registry, there are now ${this.getRegistrySize()}`;
        if (this.getRegistrySize() > 0) {
            console.warn(msg, this._registry);
        } else {
            console.log(msg);
        }
    },

    getRegistrySize() {
        return _.size(this._registry);
    },

    getSpecialHeaders() {
        let headers = {};
        headers = _.extend(headers, OAuth.getHeader());
        headers = _.extend(headers, Impersonate.getHeader());
        return headers;
    },

    getSpecialParameters() {
        let parameters = {};
        parameters = _.extend(parameters, OAuth.getParameter());
        parameters = _.extend(parameters, Impersonate.getParameter());
        return parameters;
    },

    getAccessQueryParameters() {
        // jshint camelcase:false
        const activeLanguage = getActiveLanguage();
        return {
            access_token: OAuth.getAccessToken(),
            'rest-impersonate-user': Impersonate.getImpersonated(),
            _locale: activeLanguage.bCode,
        };
    },
});

export default BaseApplication;
